import React from "react";
import useSingleOrganization from "../../../hooks/useSingleOrganization";
import CreateUserLinkListPresenter from "../../../../createUserLink/components/CreateUserLinkList/CreateUserLinkList/CreateUserLinkListPresenter";
import { OrderByType } from "../../../../../utils/genericAPI/useGenericAPI";
import { CreateUserLink } from "../../../../createUserLink/types/createUserLink.type";

export default function CreateUserTokenListPresenter({pageSize, orderBy}:{pageSize?: number, orderBy?: OrderByType<CreateUserLink>}) {
  const { organizationId } = useSingleOrganization()
  return <CreateUserLinkListPresenter organizationId={organizationId} pageSize={pageSize} orderBy={orderBy}/>;
}
